module.exports = __webpack_public_path__ + "img/redirect.c65eefc0.svg";